import { env } from '$env/dynamic/public';
import type {
  PageData,
  GeneralSettings,
  GeneralSettingsDraft,
  LandingPageModel,
  SupportData,
  PromoData,
} from 'customer-components/lib/types';

export const Request = async (url: string) => {
  try {
    const res = await fetch(url);

    if (Math.floor(res.status / 100) !== 2) {
      const extensionResponse = res.clone();
      const jsonResponse = await res.json();
      // todo: type responses
      extensionResponse.codes = jsonResponse?.validation?.codes;
      extensionResponse.message = jsonResponse?.message || jsonResponse;

      throw extensionResponse;
    }

    return await res.json();
  } catch (err) {
    throw err;
  }
};

export const getPageData = async (
  businessName: string,
  pageName: string,
  pageType: string = 'default',
): Promise<PageData> => {
  try {
    return await Request(
      `${
        env.PUBLIC_API_URL
      }/public/websitev2/${businessName}/pages/${pageName.replaceAll(
        '/',
        '',
      )}?websitePageType=${pageType}`,
    );
  } catch (err) {
    throw new Error(
      `REF:"catchall-pageData-error" | BUSINESS:"${businessName}" | PAGE:"${pageName}" | ERROR:"${
        err?.message?.errors[0].code || 'undefined error'
      }"`,
    );
  }
};

export const getPageDataDraft = async (
  businessName: string,
  pageName: string,
  pageType: LandingPageModel['pageType'] = 'default',
): Promise<PageData> => {
  const res = await fetch(
    `${
      env.PUBLIC_API_URL
    }/public/websitev2/${businessName}/draftpages/${pageName.replaceAll(
      '/',
      '',
    )}?websitePageType=${pageType}`,
  );
  return await res.json();
};

export const getPageGeneralSettings = async (
  businessName: string,
): Promise<GeneralSettings> => {
  try {
    return await Request(
      `${env.PUBLIC_API_URL}/public/websitev2/${businessName}/generalsettings`,
    );
  } catch (err) {
    throw new Error(
      `REF:"catchall-generalSettings-error" | BUSINESS:"${businessName}" | ERROR:"${
        err?.message?.errors[0].code || 'undefined error'
      }"`,
    );
  }
};

export const getPageGeneralSettingsDraft = async (
  businessName: string,
): Promise<GeneralSettingsDraft> => {
  try {
    return await Request(
      `${env.PUBLIC_API_URL}/public/websitev2/${businessName}/generalsettingsdraft`,
    );
  } catch (err) {
    throw new Error(
      `REF:"catchall-generalSettings-error" | BUSINESS:"${businessName}" | ERROR:"${
        err?.message?.errors[0].code || 'undefined error'
      }"`,
    );
  }
};

export const getSupportData = async (
  businessName: string,
): Promise<SupportData> => {
  const res = await fetch(
    `${env.PUBLIC_API_URL}/public/websitev2/${businessName}/support`,
  );
  return await res.json();
};

export const createLead = async (
  businessName: string,
  pageType: 'default' | 'marketing' = 'default',
  data,
): Promise<any> => {
  const response = await fetch(
    `${env.PUBLIC_API_URL}/public/websitev2/${businessName}/leads?websitePageType=${pageType}`,
    {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  );

  return await response.json();
};

export const getPromoPageData = async (
  lpkey: string,
  pageNumber: string,
): Promise<PromoData> => {
  const response = await fetch(
    `${env.PUBLIC_API_URL}/public/websitev2/lp/${lpkey}/${pageNumber}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  );

  return await response.json();
};
